import { useLocation } from "react-router-dom";
import { DepartmentContent } from "../../components/app";

export default function Department() {
  let location = useLocation();

  return <>{location?.state?.page === "details" ? null : <DepartmentContent />}</>;
}
